//--------------------------------------------------------------------//
//******************** AgentVoiceService ******************************//
//--------------------------------------------------------------------//
// API communication layer for an agent's SIP voice-calling config
// (agent.voice — see gudhub-agents' agents.database.js).
import { request } from '../agents.request.js';

angular.module('agentsTableModule')

    .service('AgentVoiceService', [function () {
        // Fetches every registered AI provider and filters to the ones that
        // support SIP voice calling (supports_calling, added by gudhub-agents'
        // GET /providers) — only openai/grok today, but fetched live rather
        // than hardcoded so this list doesn't drift if that changes.
        this.getCallingProviders = function () {
            return request('/providers', {}, 'GET').then(function (providers) {
                return (providers || []).filter(function (provider) {
                    return provider.supports_calling;
                });
            });
        };

        // Persists voice config. Sends the agent_id plus a full voice object —
        // POST /update merges voice.* sub-keys individually server-side, so
        // sending the whole object is equivalent to sending only what changed.
        this.update = function (agentData) {
            return request('/update', agentData);
        };
    }]);
